import { render, staticRenderFns } from "./DashboardSubeler.vue?vue&type=template&id=63939069&"
import script from "./DashboardSubeler.vue?vue&type=script&lang=js&"
export * from "./DashboardSubeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports